module.exports = __webpack_public_path__ + "static/media/hand-point-right.3b1b283b.svg";